import { Address } from '~/types';
import i18n from '~/i18n';

const t = i18n.t.bind(i18n);

const buildAddress = (address?: Address): string => {
  const result = [];

  if (address) {
    const { country, region, city, addressLine, postalCode } = address;
    if (postalCode) result.push(postalCode);
    if (addressLine) result.push(addressLine);
    if (city) result.push(city);
    if (region) result.push(region);
    if (country) result.push(t(`countries:${country}`));
  }

  return result.join(', ');
};

export default buildAddress;
